import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Piece} from '../../../../models/piece.model';
import {FicheIntervention} from '../../../../models/ficheIntervention.model';
import {forEach, map} from 'lodash-es';
import {FicheInterventionService} from '../../../../services/fiche-intervention.service';
import {WorkOrderType} from '../../../../models/workOrderType.model';
import {WorkOrder} from '../../../../models/workOrder.model';

@Component({
    selector: 'app-modal-work-order', templateUrl: './modal-work-order.component.html',
})
export class ModalWorkOrderComponent implements OnInit {
    @Input() ficheIntervention: FicheIntervention;
    @Input() pieces: Piece[] = [];
    @Input() workOrderTypes: WorkOrderType[] = [];
    @Input() workOrder: WorkOrder = new WorkOrder();

    success: boolean = false;
    error: boolean = false;

    definitions: object[] = [];

    selectTypeForm = new FormGroup({
        searchText: new FormControl('')
    });
    form: FormGroup;
    formData = [];

    constructor(private ficheInterventionService: FicheInterventionService, public dialogRef: MatDialogRef<ModalWorkOrderComponent>,) {
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            id: new FormControl(this.workOrder.id),
            type: new FormControl(this.workOrder.type),
            piece_id: new FormControl(this.workOrder.piece_id, [Validators.required]),
            fiche_intervention_id: new FormControl(this.ficheIntervention.id, [Validators.required]),
            data: new FormGroup({}),
        });

        const types = [];
        if (this.workOrder.type) {
            types.push(this.workOrder.type);
        }
        this.selectTypeForm = new FormGroup({
            types: new FormControl(types),
            piece_id: new FormControl(this.workOrder.piece_id, [Validators.required]),
            searchText: new FormControl(''),
        });

        this.form.valueChanges.subscribe(() => this.onFormChange());

        const workOrderType = this.workOrderTypes.find(workOrderT => workOrderT.name === this.form.value.type);
        if (workOrderType) {
            this.reloadDefinitions(workOrderType);
        }

    }

    onFormChange(): void {
        if (this.form.value.type) {
            const workOrderType = this.workOrderTypes.find(workOrderT => workOrderT.name === this.form.value.type);
            if (workOrderType && workOrderType.definitions !== this.definitions) {
                this.reloadDefinitions(workOrderType);
            }
        }
    }

    get filterWorkOrderTypes() {
        const searchText = this.selectTypeForm.value.searchText;
        if (!searchText) {
            return this.workOrderTypes;
        }
        return this.workOrderTypes.filter(workOrderType => workOrderType.name.toLowerCase().includes(searchText.toLowerCase()));
    }

    reloadDefinitions(workOrderType): void {
        const data = new FormGroup({});
        this.definitions = workOrderType.definitions;
        forEach(workOrderType.definitions, (d: object) => {
            const key = d['key'];
            data.addControl(key, new FormControl(this.workOrder.data[key] ?? this.form.value.data[key] ?? ''));
        });
        this.form.setControl('data', data);

        this.formData = map(this.form.value.data, (d, k) => (k));
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;

        const forms = map(this.selectTypeForm.value.types, (type: string) => {
            const form = new FormGroup({
                id: new FormControl(this.workOrder.id),
                type: new FormControl(type), // Use the current type from iteration
                piece_id: new FormControl(this.selectTypeForm.get('piece_id').value, [Validators.required]),
                fiche_intervention_id: new FormControl(this.ficheIntervention.id, [Validators.required]),
                data: new FormGroup({}),
            });

            if (!form.valid) {
                throw new Error('Invalid form');
            }
            return form;
        });

        Promise.all(map(forms, (form: FormGroup) => new Promise((resolve) => {
            this.ficheInterventionService.storeOrUpdateWorkOrder(form.value).subscribe(() => {
                resolve(true);
            });
        }))).then(() => {
            this.success = true;
            this.dialogRef.close();
        });

    }

    getDefinitionType(type): string {
        switch (type) {
            case 'autocomplete':
                return 'autocomplete';
            case 'number':
                return 'number';
            case 'boolean':
                return 'checkbox';
            case 'string':
            default:
                return 'string';
        }
    }

    getDefinition(i: any): object {
        return this.definitions[i];
    }

    trackFn(i, item): string {
        return item;
    }
}
